module.exports = __webpack_public_path__ + "static/media/md-volume-mute.e7422c3f.svg";